import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/agb/Agb.tsx");
